var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFriendlyNot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_1273101_cc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.6496 21.0469H18.5605C18.299 21.0469 18.1248 21.2212 18.1248 21.4826V36.4716C18.1248 36.733 18.299 36.9073 18.5605 36.9073H28.6693V39.1295H25.9243C25.6628 39.1295 25.4885 39.3038 25.4885 39.5652C25.4885 39.8267 25.6628 40.001 25.9243 40.001H32.2423C32.5037 40.001 32.678 39.8267 32.678 39.5652C32.678 39.3038 32.5037 39.1295 32.2423 39.1295H29.5408V36.9073H39.6496C39.9111 36.9073 40.0854 36.733 40.0854 36.4716V21.4826C40.0854 21.2647 39.8675 21.0469 39.6496 21.0469ZM39.2139 21.9183V33.2908H18.9962V21.9183H39.2139ZM18.9962 36.0359V34.2058H39.2139V36.0359H18.9962Z",
    fill: "#EB3223"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.18935 22.5271C7.57438 22.5271 7.88651 22.215 7.88651 21.83C7.88651 21.4449 7.57438 21.1328 7.18935 21.1328C6.80432 21.1328 6.49219 21.4449 6.49219 21.83C6.49219 22.215 6.80432 22.5271 7.18935 22.5271Z",
    fill: "#EB3223"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.3354 23.4856V0.435726C14.3354 0.17429 14.1611 -4.15541e-08 13.8997 -4.15541e-08H0.435726C0.17429 -4.15541e-08 0 0.17429 0 0.435726V23.4856C0 23.7471 0.17429 23.9214 0.435726 23.9214H13.8561C14.1175 23.9214 14.3354 23.7471 14.3354 23.4856ZM13.4639 0.871452V19.6948H0.871452V0.871452H13.4639ZM0.871452 23.0499V20.5663H13.4204V23.0499H0.871452Z",
    fill: "#EB3223"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.2098 31.5901H8.58239V25.3156C8.58239 25.0542 8.4081 24.8799 8.14666 24.8799C7.88523 24.8799 7.71094 25.0542 7.71094 25.3156V32.0258C7.71094 32.2872 7.88523 32.4615 8.14666 32.4615H17.2098C17.4712 32.4615 17.6455 32.2872 17.6455 32.0258C17.6455 31.7644 17.4276 31.5901 17.2098 31.5901Z",
    fill: "#EB3223"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.8183 8.19176H22.0928V19.5642C22.0928 19.8257 22.267 19.9999 22.5285 19.9999C22.7899 19.9999 22.9642 19.8257 22.9642 19.5642V7.75604C22.9642 7.4946 22.7899 7.32031 22.5285 7.32031H15.8183C15.5569 7.32031 15.3826 7.4946 15.3826 7.75604C15.3826 8.01747 15.5569 8.19176 15.8183 8.19176Z",
    fill: "#EB3223"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFriendlyNot);
export default __webpack_public_path__ + "static/media/mobileFriendlyNot.7362fe6736770db53543c0dcb96adf42.svg";
export { ForwardRef as ReactComponent };